import React, {Fragment} from 'react';
import createEditor from '../form/ComponentEditor';
import BoxEditor from "./BoxEditor";
import SelectorGrid from "../form/SelectorGrid/SelectorGrid";
import Tabs from "../layout/Tabs";
import TabContent from "../layout/TabContent";
import {ProductColumn, UnitFormatter} from "../../utils/formatters";
import moment from "moment";
import DateTimeInput from "../form/DateTimeInput";
import Button from "../form/Button";
import Select from "../form/Select";
import connect from "../../reducers/connect";
import Modal from "../layout/Modal";
import Portal from "../layout/Portal";

const sortable = true;
const filterable = true;

class DateFilter extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            from: this.props.from,
            to: this.props.to
        }
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        const state = {};
        if (this.props.from !== prevProps.from && this.state.from === prevState.from) {
            state.from = this.props.from;
        }
        if (this.props.to !== prevProps.to && this.state.to === prevState.to) {
            state.to = this.props.to;
        }
        if (Object.keys(state).length) {
            this.setState(state);
        }
    }

    render() {
        const disabled = this.state.from === this.props.from && this.state.to === this.props.to;
        return (
            <div className="row">
                <div className="col-md-3">
                    <div className="form-group">
                        <DateTimeInput
                            maxDate={this.state.to}
                            value={this.state.from}
                            label="Időszak"
                            saveChanges={(field, from) => this.setState({from})}
                        />
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="form-group">
                        <DateTimeInput
                            minDate={this.state.from}
                            value={this.state.to}
                            label="&nbsp;"
                            saveChanges={(field, to) => this.setState({to})}
                        />
                    </div>
                </div>
                <div className="col-md-2">
                    <label className="control-label">&nbsp;</label>
                    <Button
                        color={disabled ? "default" : "primary"}
                        disabled={disabled}
                        block={true}
                        icon={{lib: "fa", name: "search"}}
                        onClick={() => {
                            this.props.onFilter({from: this.state.from, to: this.state.to});
                        }}
                    >
                        Szűrés
                    </Button>
                </div>
            </div>
        );
    }
}

class InvoiceFilterComp extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            invoice: this.props.invoice,
        }
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        const state = {};
        if (this.props.invoice !== prevProps.invoice && this.state.invoice === prevState.invoice) {
            state.invoice = this.props.invoice;
        }
        if (Object.keys(state).length) {
            this.setState(state);
        }
    }

    render() {
        const disabled = this.props.invoice === this.state.invoice;
        return (
            <div className="row">
                <div className="col-md-6">
                    <div className="form-group">
                        <Select
                            component="invoice"
                            objectValue={false}
                            label="Számlaszám"
                            labelKey="billnum"
                            value={this.state.invoice}
                            filter={[{field: "to", value: this.props.pos.partner.partner_id},{field: "type", value: 1},{field: "storno", operator: "isnull"}]}
                            saveChanges={(field, invoice) => this.setState({invoice})}
                        />
                    </div>
                </div>
                <div className="col-md-2">
                    <div className="form-group">
                        <label className="control-label">&nbsp;</label>
                        <Button
                            color={disabled ? "default" : "primary"}
                            disabled={disabled}
                            block={true}
                            icon={{lib: "fa", name: "search"}}
                            onClick={() => {
                                this.props.onFilter({invoice: this.state.invoice});
                            }}
                        >
                            Szűrés
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
}

const InvoiceFilter = connect((state) => {
    return {
        pos: state.app.till.pos,
    }
})(InvoiceFilterComp);

class InvoiceModal extends React.Component {

    state = {
        opened: false
    }

    render() {
        return (
            <Fragment>
                <Portal>
                    <Modal
                        header={this.props.row.displayname}
                        size="large"
                        state={this.state.opened}
                        buttons={[
                            {
                                text: 'Bezárás',
                                props: {color: "default", disabled: this.props.disabled || this.props.isLoading},
                                onClose: true,
                                onClick: async () => {
                                    try {
                                        this.setState({opened: !this.state.opened});
                                    } catch (e) {
                                    }
                                }
                            },
                        ]}
                    >
                        <SelectorGrid
                            key="2"
                            component={this.props.componentConfig.componentname}
                            view={["id"]}
                            parameters={{
                                stat_type: "sold",
                                product: this.props.row.id,
                                invoice: this.props.invoice,
                            }}
                            aggregations={{fields: {sold: {type: "SUM"}}}}
                            columns={{
                                "displayname": {
                                    ...ProductColumn("id"),
                                    width: 7,
                                },
                                "salemonth": {
                                    header: 'Hónap',
                                    width: 2,
                                    className: "nowrap",
                                    sortable,
                                    renderer: (month) => moment().month(month - 1).format("MMMM"),
                                    operator: "=",
                                    filterable: <Select
                                        storeType="local"
                                        options={[1,2,3,4,5,6,7,8,9,10,11,12].map((month) => {
                                            return {key: month, label: moment().month(month - 1).format("MMMM")}
                                        })}
                                        label={false}
                                        objectValue={false}
                                        isClearable={true}
                                        valueKey="key"
                                        labelKey="label"
                                    />,
                                },
                                "sold": {
                                    header: 'Eladva',
                                    width: 1,
                                    sortable,
                                    filterable,
                                    renderer: (value, row) => UnitFormatter(value, row.unit),
                                    className: "unit"
                                }
                            }}
                            sortBy={{field: "salemonth", direction: "ASC"}}
                            orderBy={{field: "displayname", direction: "ASC"}}
                        />
                    </Modal>
                </Portal>
                <a onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.setState({opened: !this.state.opened})
                }}>
                    {UnitFormatter(this.props.value, this.props.row.unit)}
                </a>
            </Fragment>
        );
    }
}

class FranchiseSettlementStatEditor extends React.Component {

    state = {
        tab: "sold",
        from: moment().subtract(1, "months").startOf('month').format("YYYY-MM-DD"),
        to: moment().subtract(1, "months").endOf('month').format("YYYY-MM-DD")
    }

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    render() {
        const startdate = this.state.from + " 00:00:00";
        const enddate = this.state.to + " 23:59:59";
        return <Fragment>
            <Tabs
                theme="default"
                defaultTab="product"
                onTabChange={(tab) => this.setState({tab})}
                currentTab={this.state.tab}
            >
                {/*<TabContent
                    tabLabel="Eladva/Számlázva"
                    tabName="product"
                >
                    <DateFilter
                        from={this.state.from}
                        to={this.state.to}
                        onFilter={({from, to}) => {
                            this.setState({from, to});
                        }}
                    />
                    <SelectorGrid
                        key="1"
                        component={this.props.componentConfig.componentname}
                        view={["id"]}
                        parameters={{
                            stat_type: "product",
                            startdate,
                            enddate,
                        }}
                        aggregations={{fields: {sold: {type: "SUM"}, billed: {type: "SUM"}}}}
                        columns={{
                            "displayname": {
                                ...ProductColumn("id"),
                                width: 10,
                            },
                            "sold": {
                                header: 'Eladás',
                                width: 1,
                                sortable,
                                filterable,
                                renderer: (value, row) => UnitFormatter(value, row.unit),
                                className: "unit"
                            },
                            "billed": {
                                header: 'Számlázva',
                                width: 1,
                                sortable,
                                filterable,
                                renderer: (value, row) => UnitFormatter(value, row.unit),
                                className: "unit"
                            }
                        }}
                        orderBy={{field: "displayname", direction: "ASC"}}
                    />
                </TabContent>*/}
                <TabContent
                    tabLabel="Elszámolás dátum szerint"
                    tabName="sold"
                >
                    <DateFilter
                        from={this.state.from}
                        to={this.state.to}
                        onFilter={({from, to}) => {
                            this.setState({from, to});
                        }}
                    />
                    <SelectorGrid
                        key="2"
                        component={this.props.componentConfig.componentname}
                        view={["id"]}
                        parameters={{
                            stat_type: "sold",
                            startdate,
                            enddate,
                        }}
                        aggregations={{fields: {sold: {type: "SUM"}}}}
                        columns={{
                            "displayname": {
                                ...ProductColumn("id"),
                                width: 7,
                            },
                            "salemonth": {
                                header: 'Hónap',
                                width: 2,
                                className: "nowrap",
                                sortable,
                                renderer: (month) => moment().month(month - 1).format("MMMM"),
                                operator: "=",
                                filterable: <Select
                                    storeType="local"
                                    options={[1,2,3,4,5,6,7,8,9,10,11,12].map((month) => {
                                        return {key: month, label: moment().month(month - 1).format("MMMM")}
                                    })}
                                    label={false}
                                    objectValue={false}
                                    isClearable={true}
                                    valueKey="key"
                                    labelKey="label"
                                />,
                            },
                            "sold": {
                                header: 'Eladva',
                                width: 1,
                                sortable,
                                filterable,
                                renderer: (value, row) => UnitFormatter(value, row.unit),
                                className: "unit"
                            },
                            "invoice.billnum": {
                                header: 'Számlaszám',
                                width: 2,
                                className: "nowrap",
                                sortable,
                                filterable,
                            },
                            "invoice.invoice_id": {
                                header: ' ',
                                width: 'cell-button',
                                className: "nowrap",
                                renderer: (value) => {
                                    return !!value && <Button
                                        color="default"
                                        size="xs"
                                        icon={{lib: "fas", name: "share"}}
                                        onClick={() => this.setState({tab: "billed", invoice: value})}
                                    />;
                                }
                            },
                        }}
                        sortBy={{field: "salemonth", direction: "ASC"}}
                        orderBy={{field: "displayname", direction: "ASC"}}
                    />
                </TabContent>
                <TabContent
                    tabLabel="Elszámolás számlaszám szerint"
                    tabName="billed"
                >
                    <InvoiceFilter
                        invoice={this.state.invoice}
                        onFilter={({invoice}) => {
                            this.setState({invoice});
                        }}
                    />
                    {this.state.invoice && <SelectorGrid
                        key="3"
                        component={this.props.componentConfig.componentname}
                        view={["id"]}
                        parameters={{
                            stat_type: "billed",
                            invoice: this.state.invoice,
                        }}
                        filter={{field: "invoice", value: this.state.invoice}}
                        aggregations={{fields: {billed: {type: "SUM"}}}}
                        columns={{
                            "displayname": {
                                ...ProductColumn("id"),
                                width: 9,
                            },
                            "billed": {
                                header: 'Számlázva',
                                width: 1,
                                sortable,
                                filterable,
                                renderer: (value, row, rowIndex, props, parent) => props.isAggregation ? UnitFormatter(value, row.unit) : <InvoiceModal row={row} value={value} invoice={this.state.invoice} componentConfig={this.props.componentConfig} setState={(state, cb) => this.setState(state, cb)} />,
                                className: "unit",
                            },
                        }}
                        orderBy={{field: "displayname", direction: "ASC"}}
                    />}
                </TabContent>
            </Tabs>
        </Fragment>;
    }
}

export default createEditor({
    componentName: "FranchiseSettlementStat",
    WrappedComponent: FranchiseSettlementStatEditor
});
